export default "__VITE_ASSET__rPI9OZ_e__"